/* Default Colors */
/* CI/CD Colors */
/* 2021 TS Colors */
/* Scrollbars */
.expandable-list {
  list-style: none;
  margin: 0;
  padding: 0;
}